var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('team',{attrs:{"items":_vm.items,"loading":_vm.loading,"search":_vm.search,"is-integrated":_vm.isIntegrated,"page-size":_vm.pageSize},on:{"get-profiles-data":_vm.getProfilesData,"click":_vm.onClick,"on-search":_vm.onSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }